import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as Cookies from 'js-cookie';
import { wcagOptions } from "./wcag";
import { siteGeneral } from "./site";

export class travelAdvisory {
    private wcag = new wcagOptions();
    $scope: any = $('.travel-advisory-search--holder');

    traveladvisoryDispOnCountrySele(): void {
        $('.travel-advisory-search--holder .btn').on('click', (e: any) => {
            let countryName: any = $('.travel-advisory-search--holder .selectize-input .name').text().toLowerCase();
            countryName = countryName.replace(',', '-');
            countryName = countryName.replace(/\s/g, "");
            let urltravelAd: any = 'https://' + window.location.hostname + '/mhapp/hq/en/important-notice/' + countryName + '.html';
            $('#iframeTravelAdvisory').attr('src', urltravelAd);
            $('#iframeTravelAdvisory').show();
            $('#iframeTravelAdvisory').css('height', '2500px');
        });
        $('#iframeTravelAdvisory').load(function () {
            $(this).height($(this).contents().find("body").height());
        });
        $('.travel-advisory-search--holder .btn').attr('disabled', 'disabled');
    }
    countrySelector(): void {
        let _self = this;
        let countryData: Array<countryData>;
        let countrySelector: any = _self.$scope.find('.countrySelector');

        function getCountrySelectorData() {
            let defer = $.Deferred();
            let dataUrl: string = $('.travel-advisory-search--holder').attr('data-get-url');
            $.get(dataUrl)
                .done((res: any) => {
                    let data: any;
                    if (typeof res === 'string') {
                        data = JSON.parse(res);
                    } else {
                        data = res;
                    }
                    data.countrysList[0].countries.push({ countryName: "Brunei", src: "", languages: [] });
                    data.countrysList[0].countries.push({ countryName: "Cambodia", src: "", languages: [] });
                    data.countrysList[0].countries.push({ countryName: "Myanmar", src: "", languages: [] });
                    data.countrysList[0].countries.push({ countryName: "Bangladesh", src: "", languages: [] });
                    data.countrysList[0].countries.push({ countryName: "Nepal", src: "", languages: [] });
                    data.countrysList[0].countries.push({ countryName: "Sri Lanka", src: "", languages: [] });
                    data.countrysList[0].countries.push({ countryName: "Saudi Arabia", src: "", languages: [] });
                    defer.resolve(data);
                })
                .fail((error: any) => {
                    defer.reject(error);
                });
            return defer.promise();
        }
        getCountrySelectorData().done((res: any) => {
            countryData = cleanCountryData(res.countrysList).sort(function (a, b) {
                var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0;
            });
            countryData = $.grep(countryData, function (e: any) { return e.name.toLowerCase() !== 'america' && e.name.toLowerCase() !== 'global' });
            let elemExists: number = countryData.findIndex((el2: any) => {
                return el2.name.toLowerCase() === 'malaysia';
            });
            if (elemExists > 0) {
                let resItem: countryData = countryData[elemExists];
                countryData = $.grep(countryData, function (e: any) { return e.name.toLowerCase() !== 'malaysia' });
                countryData.splice(0, 0, resItem);
            }
            initCountrySelector(countrySelector, countryData);

        });
        function initCountrySelector(countrySelectorInstance: any, countries: Array<countryData>): void {
            countrySelectorInstance.selectize({
                valueField: 'name',
                labelField: 'name',
                searchField: ['name', 'region'],
                options: countries,
                create: false,
                selectOnTab: true,
                placeholder: 'Country',
                render: {
					/**
					 * render custom selectize item ui
					 * @param {any} item   [item variable]
					 * @param {any} escape [escape char function]
					 */
                    item: function (item: any, escape: any) {
                        return '<div>' +
                            (item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
                            '</div>';
                    },
					/**
					 * render custom selectize option ui
					 * @param {any} item   [item variable]
					 * @param {any} escape [escape char function]
					 */
                    option: function (item: any, escape: any) {
                        return '<div>' +
                            (item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
                            '</div>';
                    }
                },
                onInitialize: function () {
                    _self.wcag.selectizeInputAria(countrySelectorInstance[0].selectize);
                },
                onChange: function (value: any) {
                    if (value != '') {
                        $('.travel-advisory-search--holder .btn').removeAttr('disabled');
                    }
                }
            });
        }
        function cleanCountryData(data: Array<rawCountryData>): Array<countryData> {
            let countries: Array<countryData> = [];
            let countriesIndex: number = 0;

            // consolidate all countries irregardless of region
            for (var i = 0, len = data.length; i < len; i++) { // loop thru region
                for (var j = 0, jlen = data[i].countries.length; j < jlen; j++) { // loop thru countries
                    countries[countriesIndex] = {
                        name: data[i].countries[j].countryName,
                        region: data[i].regionName,
                        flag: data[i].countries[j].src,
                        languages: data[i].countries[j].languages
                    };
                    countriesIndex++;
                }
            }
            return countries;
        }
    }
    switchRestrictionsContent (){
        $('.travel-advisory-search--holder .row').slice(3,5).hide()
        let url = 'https://' + window.location.hostname + '/mhapp/hq/en/important-notice/' + 'malaysia' + '.html'
        $('#iframeTravelAdvisory').attr('src', url);
        $('#iframeTravelAdvisory').hide();
        $('input[name="selectedArea"][type="radio"]').change(function(){
            if($(this).val()==='malaysia'){
                $('#iframeTravelAdvisory').show()
                $('.smartvel-search').hide();
                $('#iframeTravelAdvisory').css('height', '2500px');
            }
            else{
                $('.smartvel-search').show()
                $('#iframeTravelAdvisory').hide()
            }
        });
        
    }

}

let scope: Element = document.querySelector('.travel-advisory-search--holder');
if (scope) {
    try {
        let traveladvisory = new travelAdvisory();
        traveladvisory.countrySelector();
        traveladvisory.traveladvisoryDispOnCountrySele();
        traveladvisory.switchRestrictionsContent()
    } catch (e) { console.error(e); }
}